import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const authSlice = createSlice({
    name: 'auth',
    initialState: { token: null as string | null, user: { details: null, isAuthenticated: false, isSSOUser: false } }, // Update the type of state.token
    reducers: {
        setToken: (state, action) => {
            state.token = action.payload;
        },
        setUserDetails: (state, action) => {
            state.user = action.payload;
        },
        setUserMetadata: (state, action: PayloadAction<Record<string, unknown>>) => {
            if (!state.user?.details) return;
            const currentDetails = state.user.details as Record<string, any>;
            state.user.details = {
                ...currentDetails,
                user_metadata: {
                    ...(currentDetails.user_metadata ?? {}),
                    ...action.payload,
                }
            } as any;
        }
    },
});

export default authSlice.reducer;
export const { setToken, setUserDetails, setUserMetadata } = authSlice.actions;